export interface LoadingSpinnerProps {
  /** Text shown below the spinner */
  text?: string;
  /** Whether to fill the full viewport height (default: true) */
  fullScreen?: boolean;
}

export default function LoadingSpinner({ text = 'Зареждане...', fullScreen = true }: LoadingSpinnerProps) {
  return (
    <div className={`flex items-center justify-center ${fullScreen ? 'min-h-screen' : 'py-24'}`}>
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" />
        {text && <p className="mt-4 text-gray-600">{text}</p>}
      </div>
    </div>
  );
}
